import { inject } from 'mobx-react';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { handleInstaLink } from '@/utils';
import MiddleModal from '@/components/MiddleModal';
import styles from './index.module.less';
import SubmitBtn from '@/components/SubmitBtn';
import MarkdownRender from '@/components/MarkdownRender';

const ExchangeSuccessModal = inject(
  'area',
  'app'
)(
  forwardRef((props, ref) => {
    const [visible, setVisible] = useState(false);
    const [showFooter, setShowFooter] = useState(true);
    const { LANG } = props.area;
    const { hasTip, tipContent } = props;

    useImperativeHandle(ref, () => ({
      toggleVisible,
    }));

    const toggleVisible = (visible, opt = {}) => {
      setVisible(visible);
      // TODO 不好的写法，待优化
      if (visible) {
        setShowFooter(opt.showFooter ?? true);
      }
    };

    const navigationToMyCoupon = () => {
      window.location.href = handleInstaLink('www', '/account/coupon', props.app);
    };

    return (
      <MiddleModal
        title={LANG['common.tips.redeemSuccessful']}
        footer={null}
        theme='float'
        visible={visible}
        wrapClassName={styles.successModal}
        onCancel={() => toggleVisible(false)}
      >
        <div className={styles.modalContent}>
          {hasTip ? <MarkdownRender text={tipContent} /> : LANG['common.tips.redeemSuccessfulTips']}
        </div>
        {showFooter && (
          <div className={styles.modalFooter}>
            <div className={styles.btnGroup}>
              <SubmitBtn className={styles.cancel} onClick={() => window.location.reload()}>
                {LANG['common.btn.continueShopping']}
              </SubmitBtn>
              <SubmitBtn className={styles.submit} onClick={navigationToMyCoupon}>
                {LANG['common.btn.viewMyItem']}
              </SubmitBtn>
            </div>
          </div>
        )}
      </MiddleModal>
    );
  })
);

export default ExchangeSuccessModal;
